import { Branch } from './branch.model';

export class BusinessUnit {
  id?: number;

  branch_id?: number;

  code?: string;
  label?: string;

  branch?: Branch;

  // appended properties by the backend, not in the original model
  name?: string;
  bu_entity?: string;

  constructor(data = {}) {
    Object.assign(this, data);

    if (this.branch) { this.branch = new Branch(this.branch); }
  }
}
